import { render } from "./DateComponent.vue?vue&type=template&id=31d04143&scoped=true"
import script from "./DateComponent.vue?vue&type=script&lang=js"
export * from "./DateComponent.vue?vue&type=script&lang=js"

import "./DateComponent.vue?vue&type=style&index=0&id=31d04143&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d04143"]])

export default __exports__